<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @imp="imp" @exps="exps" @del="delall" @save="save"
                    ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs v-model="activeName" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[3608]')" name="0">
                        <!-- 表格 -->
                        <wTable
                                id="xpane-0"
                                :data="datajson"
                                :loading="loading"
                                queryData="SchVenderMasterViewInfo"
                                :filter_language="['isHaveTechDept','isSelfStudy','Quality_Ablity_FLAG','tax_flag','vender_Status','BatchPrice_Flag','Important_Level_Id','login_vend']"
                                :filter_thousandth_puramount="['limit_amount']"
                                :filter_date="['Effect_Date','Certificate_Effect']"
                                :header="tableHeader"
                                :option="tableOption"
                                :row-class-name="tableRowClassName"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                :checkflg="false"
                                ref="singleTable"
                        ></wTable>
                        <!--<el-table
                                :data="datajson"
                                v-loading="loading"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @cell-dblclick="editInfo"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange"
                                :highlight-current-row="true"
                                ref="singleTable"
                                @row-click="edits"
                                @row-dblclick="openEdit"
                                :row-class-name="tableRowClassName"
                                style="width: 100%; margin-top:2px"
                                :header-cell-style="$limits.headerClass"
                        >
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1196]')"
                                             width="100">
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd clerinput"
                                            @keydown="shows($event, scope.$index)"
                                            @keyup="show($event, scope)"
                                            v-model="scope.row.Vender_code"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="sort_Id" :label="$t('getapi[1198]')"
                                             width="140"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"
                                             width="200"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_property" :label="$t('getapi[1199]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Grade_Id" :label="$t('getapi[1095]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Important_Level_Id" :label="$t('getapi[1097]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Developer" :label="$t('getapi[1200]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Address" :label="$t('getapi[1201]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Legal_Person" :label="$t('getapi[1167]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Effect_Date" :label="$t('getapi[548]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="phone_number" :label="$t('getapi[1202]')"
                                             align="right" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Fax_Number" :label="$t('getapi[1203]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Contact_Person" :label="$t('getapi[1204]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Contact_person_Post"
                                             :label="$t('getapi[1205]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Post_Code" :label="$t('getapi[1206]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Mail_address" :label="$t('getapi[1207]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Supply_Products" :label="$t('getapi[1208]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invalid_Date" :label="$t('getapi[549]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Examination" :label="$t('getapi[1209]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_Status" :label="$t('getapi[1237]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[135]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[410]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_person" :label="$t('getapi[733]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[732]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_person" :label="$t('getapi[550]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Certificate_Effect" :label="$t('getapi[6272]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="currency(limit_amount,'$',2)" :label="$t('getapi[6273]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="login_vend" :label="$t('getapi[6274]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="BatchPrice_Flag" :label="$t('getapi[6275]')"
                                             width="80"></el-table-column>
                            <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="60">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{
                                        $t('getapi[34]') }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[184]')" name="1">
                        <!-- 表格 -->
                        <wTable
                                id="xpane-1"
                                :data="datajson"
                                :loading="loading"
                                queryData="SchVenderMasterViewInfo"
                                :filter_language="['isHaveTechDept','isSelfStudy','Quality_Ablity_FLAG','tax_flag','vender_Status','isHaveTechDept']"
                                :filter_thousandth="['limit_amount']"
                                :header="tableHeader1"
                                :option="tableOption"
                                :row-class-name="tableRowClassName"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                :checkflg="false"
                                ref="singleTable1"
                        ></wTable>
                        <!--<el-table
                                :data="datajson"
                                v-loading="loading"
                                :highlight-current-row="true"
                                ref="singleTable1"
                                @row-click="edits"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                header-row-class-name="headerclass"
                                :height="tableHeight - reduceTableHeight"
                                @cell-dblclick="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :row-class-name="tableRowClassName"
                                style="width: 100%; margin-top:0px"
                                :header-cell-style="$limits.headerClass"
                        >
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1196]')">
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd clerinput"
                                            @keydown="shows($event, scope.$index)"
                                            @keyup="show($event, scope)"
                                            v-model="scope.row.Vender_code"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Name"
                                             :label="$t('getapi[1197]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Quality_Ablity_FLAG"
                                             :label="$t('getapi[1211]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Certifications"
                                             :label="$t('getapi[1212]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Product_Std"
                                             :label="$t('getapi[1213]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="isHaveTechDept"
                                             :label="$t('getapi[1214]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="isSelfStudy"
                                             :label="$t('getapi[1215]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Protect_Method"
                                             :label="$t('getapi[1216]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Transport_Method"
                                             :label="$t('getapi[1217]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="After_Service"
                                             :label="$t('getapi[1218]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark"
                                             :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="with_days" :label="$t('getapi[6276]')"
                                             align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="60">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{
                                        $t('getapi[34]') }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1230]')" name="2">
                        <!-- 表格 -->
                        <wTable
                                id="xpane-2"
                                :data="datajson"
                                :loading="loading"
                                queryData="SchVenderMasterViewInfo"
                                :filter_language="['isHaveTechDept','isSelfStudy','Quality_Ablity_FLAG','tax_flag','vender_Status','Payment_Way','Balance_Mode']"
                                :filter_thousandth="['limit_amount']"
                                :header="tableHeader2"
                                :option="tableOption"
                                :row-class-name="tableRowClassName"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                :checkflg="false"
                                ref="singleTable2"
                        ></wTable>
                        <!--<el-table
                                :data="datajson"
                                v-loading="loading"
                                :highlight-current-row="true"
                                ref="singleTable2"
                                @row-click="edits"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                header-row-class-name="headerclass"
                                :height="tableHeight - reduceTableHeight"
                                @cell-dblclick="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :row-class-name="tableRowClassName"
                                style="width: 100%; margin-top:0px"
                                :header-cell-style="$limits.headerClass"
                        >
                            <el-table-column type="selection" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1196]')"
                                             width="100">
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd clerinput"
                                            @keydown="shows($event, scope.$index)"
                                            @keyup="show($event, scope)"
                                            v-model="scope.row.Vender_code"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"
                                             width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Payment_Clause" :label="$t('getapi[1222]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Bank_Account_Name" :label="$t('getapi[1219]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Bank_Account_Number"
                                             :label="$t('getapi[1220]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="CheckOut_Cycle" :label="$t('getapi[1221]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Payment_Way" :label="$t('getapi[1228]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="tax_flag" :label="$t('getapi[1223]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tax_Number" :label="$t('getapi[1224]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1225]')"
                                             width="100" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Financing_Type" :label="$t('getapi[1226]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"
                                             v-if="false" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Balance_Mode" :label="$t('getapi[1228]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="delivery_term" :label="$t('getapi[1229]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Electronics" :label="$t('getapi[6277]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="cloud" :label="$t('getapi[6278]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Large_amount" :label="$t('getapi[6279]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Ele_Bank" :label="$t('getapi[6280]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="bank_addr" :label="$t('getapi[6281]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="countrystate" :label="$t('getapi[6282]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_addr" :label="$t('getapi[1201]')"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="swift_aba" label="swift code"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Routing_aba" label="Routing(ABA)"
                                             width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="60">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{
                                        $t('getapi[34]') }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
                <!-- 表格 -->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <!-- 编辑弹框 -->
                <div class="box">
                    <div class="bbl">
                        <el-button type="primary" size="mini" icon="" @click.native="stat(0)"
                                   :disabled="!btn.qualified">{{$t('getapi[1234]')}}
                        </el-button>
                        <el-button type="primary" size="mini" icon="" @click.native="stat(1)"
                                   :disabled="!btn.Unqualified">{{$t('getapi[1235]')}}
                        </el-button>
                        <el-button type="primary" size="mini" icon="" @click.native="stat(2)"
                                   :disabled="!btn.QuoEnable">{{$t('getapi[1236]')}}
                        </el-button>
                        <el-button type="primary" size="mini" icon="" @click.native="stat(3)"
                                   :disabled="!btn.LimitAmount">{{$t('getapi[6283]')}}
                        </el-button>
                        <el-button type="primary" size="mini" icon="" @click.native="changepwd"
                                   :disabled="!isEdit">{{$t('getapi[1129]')}}
                        </el-button>
                    </div>
                    <!--<div class="bbl">
                        <span>{{$t('getapi[1196]')}}</span>
                        <el-input
                                class="mcolor"
                                v-model="formInline.Header.Vender_code"
                                :readonly="isEdit"
                                :class="{'readO':isEdit}"
                                size="mini"
                                maxlength="3"
                                style="width: 120px;"
                        ></el-input>
                        <span>{{$t('getapi[1197]')}}</span>
                        <el-input class="mcolor" v-model="formInline.Header.Vender_Name" size="mini"
                                  style="width: 365px;"  :readonly="formInline.Header.v_status == 1" :class="{'readO':formInline.Header.v_status == 1}" ></el-input>
                        <span>{{$t('getapi[1237]')}}</span>
                        <el-input :value="explain(formInline.Header.v_status)" size="mini"
                                  style="width: 120px;" :readonly="true" class="readO"></el-input>
                    </div>-->
                </div>
                <div style="width:800px;min-width:800px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{$t('getapi[1196]')}}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input
                                        class="mcolor"
                                        v-model="formInline.Header.Vender_code"
                                        :readonly="isEdit"
                                        :class="{'readO':isEdit}"
                                        size="mini"
                                        maxlength="3"
                                ></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{$t('getapi[1197]')}}</span></td>
                            <td style="width:320px;min-width:320px">
                                <el-input class="mcolor" v-model="formInline.Header.Vender_Name" size="mini"
                                          :readonly="formInline.Header.v_status == 1" :class="{'readO':formInline.Header.v_status == 1}" ></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{$t('getapi[1237]')}}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input :value="explain(formInline.Header.v_status)" size="mini"
                                          style="width: 120px;" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-row>
                    <el-col :span="24">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px"
                                 label-position="left" size="small">
                            <el-tabs :style="{ height: tableHeight - 300 + 'px' }">
                                <el-tab-pane :label="$t('getapi[3608]')">
                                    <div style="width:860px;min-width:860px">
                                        <table>
                                            <tr>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[1198]')}}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <routejump :urlNo="17">
                                                    <el-select filterable v-model="formInline.Header.sort_Id" :disabled="formInline.Header.v_status == 1"
                                                               class="mcolor w120">
                                                        <el-option :label="$t('getapi[6085]')" value="0"></el-option>
                                                        <el-option v-for="(item, index) in vendertypelist"
                                                                   :label="item.sort_Name" :value="item.Exclusively_Id"
                                                                   :key="index"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[1199]')}}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <el-select filterable v-model="formInline.Header.Vender_Property"
                                                               :disabled="formInline.Header.v_status == 1" class="mcolor">
                                                        <el-option v-for="(items, index) in VenderProperty" :label="items.item"
                                                                   :value="items.item" :key="index"></el-option>
                                                    </el-select>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6284]')}}</span></td>
                                                <td style="width:150px;min-width:150px">
                                                    <routejump :urlNo="18">
                                                    <el-select filterable v-model="formInline.Header.Grade_Id"
                                                               :disabled="formInline.Header.v_status == 1" class="mcolor" @change="getGradeFlag">
                                                        <el-option :label="$t('getapi[6085]')" value="0"></el-option>
                                                        <el-option v-for="(item, index) in VenderGrade" :label="item.Grade_Name"
                                                                   :value="item.Exclusively_ID" :key="index"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[1200]')}}</span></td>
                                                <td style="width:150px;min-width:150px">
                                                    <el-input v-model="formInline.Header.Vender_Developer"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1242]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Legal_Person"
                                                              class="mcolor"></el-input></td>
                                                <td><span>{{$t('getapi[1241]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Contact_Person"
                                                              ></el-input></td>
                                                <td><span>{{$t('getapi[1202]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.phone_number"
                                                              class="mcolor"></el-input></td>
                                                <td><span>{{$t('getapi[1203]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Fax_Number"
                                                              ></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1207]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Mail_Address"
                                                             ></el-input></td>
                                                <td><span>{{$t('getapi[1205]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Contact_person_Post"></el-input></td>
                                                <td><span>{{$t('getapi[548]')}}</span></td>
                                                <td><el-date-picker
                                                        v-model="formInline.Header.Effect_Date"
                                                        value-format="yyyy-MM-dd"
                                                        :readonly="formInline.Header.v_status == 1"
                                                        :class="{'readO':formInline.Header.v_status == 1}"
                                                        class="mcolor"
                                                        style="width:100%"
                                                ></el-date-picker></td>
                                                <td><span>{{$t('getapi[549]')}}</span></td>
                                                <td><el-date-picker
                                                        v-model="formInline.Header.Invalid_Date"
                                                        value-format="yyyy-MM-dd"
                                                        :readonly="formInline.Header.v_status == 1"
                                                        :class="{'readO':formInline.Header.v_status == 1}"
                                                        style="width:100%"
                                                ></el-date-picker></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1206]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Post_Code"
                                                              ></el-input></td>
                                                <td><span>{{$t('getapi[1243]')}}</span></td>
                                                <td>
                                                    <routejump :urlNo="19">
                                                    <el-select filterable v-model="formInline.Header.Important_Level_Id"
                                                               :disabled="formInline.Header.v_status == 1" class="mcolor">
                                                    <el-option :label="$t('getapi[6085]')" value="0"></el-option>
                                                    <el-option
                                                            v-for="(item, index) in VenderImportant"
                                                            :label="item.Important_Level_name"
                                                            :value="item.Exclusively_Id"
                                                            :key="index"
                                                    ></el-option>
                                                </el-select>
                                                    </routejump>
                                                </td>
                                                <td><span>{{$t('getapi[6273]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.limit_amount"
                                                              ></el-input></td>
                                                <td><span>{{$t('getapi[2587]')}}</span></td>
                                                <td>
                                                    <routejump :urlNo="20">
                                                    <el-select filterable v-model="formInline.Header.Country">
                                                    <el-option v-for="(item, index) in Country" :label="item.englishName"
                                                               :value="item.englishName" :key="index"></el-option>
                                                </el-select>
                                                    </routejump></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[6453]')}}</span></td>
                                                <td colspan="3"><el-input v-model="formInline.Header.Vender_Address"
                                                              ></el-input></td>
                                                <td><span>{{$t('getapi[2588]')}}</span></td>
                                                <td>
                                                    <routejump :urlNo="21">
                                                    <el-select filterable v-model="formInline.Header.Area">
                                                    <el-option v-for="(item, index) in AreaS" :label="item.Area_Name"
                                                               :value="item.Area_Name" :key="index"></el-option>
                                                </el-select>
                                                    </routejump></td>
                                                <td><span>{{$t('getapi[1209]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Examination"
                                                              ></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[410]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Create_person"
                                                              :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{$t('getapi[733]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Modify_person"
                                                              :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{$t('getapi[135]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Create_time"
                                                              :readonly="true" class="readO" style="width:100%"></el-input></td>
                                                <td><span>{{$t('getapi[1210]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Modify_time"
                                                              :readonly="true" class="readO" style="width:100%"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[4044]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Audit_Time"
                                                              :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{$t('getapi[1208]')}}</span></td>
                                                <td colspan="3"><el-input
                                                        v-model="formInline.Header.Supply_Products"
                                                ></el-input></td>
                                                <td><span v-if="currencyCodeType == 1">{{$t('getapi[8085]')}}</span></td>
                                                <td><el-input v-model="formInline.Header.Certificate_Effect"
                                                              class="w150"
                                                              v-if="currencyCodeType == 1"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td colspan="4">
                                                    <span>{{$t('getapi[6274]')}}</span>
                                                    <el-checkbox :true-label="1" :false-label="0"
                                                                 v-model="formInline.Header.login_vend"></el-checkbox>
                                                    <span>{{$t('getapi[8086]')}}</span>
                                                    <el-checkbox :true-label="1" :false-label="0"
                                                                 v-model="formInline.Header.BatchPrice_Flag"></el-checkbox>
                                                    <span>{{$t('getapi[8506]')}}</span>
                                                    <el-checkbox :true-label="1" :false-label="0"
                                                                 v-model="formInline.Header.SendEmail_Flag"></el-checkbox>
                                               </td>
                                                <td><span>{{$t('getapi[13358]')}}</span></td>
                                                <td><el-date-picker
                                                        v-model="formInline.Header.vender_agent_date"
                                                        value-format="yyyy-MM-dd"
                                                        :readonly="formInline.Header.v_status == 1"
                                                        class="mcolor"
                                                        style="width:100%"
                                                ></el-date-picker></td>
                                                
                                            </tr>
                                            <tr>
                                                <td colspan="4">
                                                    <span>{{$t('getapi[13501]')}}</span>
                                                    <el-checkbox :true-label=1 :false-label=0
                                                                 v-model="formInline.Header.SceneAudit_Flag"></el-checkbox>
                                                    <span>{{$t('getapi[13502]')}}</span>
                                                    <el-checkbox :true-label=1 :false-label=0
                                                                 v-model="formInline.Header.HC_Flag"></el-checkbox>
                                                    <span>{{$t('getapi[13503]')}}</span>
                                                    <el-checkbox :true-label=1 :false-label=0
                                                                 v-model="formInline.Header.YearPE_Flag"></el-checkbox>
                                                    <span>AVL</span>
                                                    <el-checkbox :true-label=1 :false-label=0
                                                                 v-model="formInline.Header.AVL_Flag"></el-checkbox>
                                                    <span>{{$t('getapi[13541]')}}</span>
                                                    <el-checkbox :true-label=1 :false-label=0
                                                                 v-model="formInline.Header.IS_Flag"></el-checkbox>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <!--<div class="box">
                                        <div class="bbl">
                                            <span>{{$t('getapi[1198]')}}</span>
                                            <el-select filterable v-model="formInline.Header.sort_Id" :disabled="formInline.Header.v_status == 1"
                                                       class="mcolor w120">
                                                <el-option :label="$t('getapi[6085]')" value="0"></el-option>
                                                <el-option v-for="(item, index) in vendertypelist"
                                                           :label="item.sort_Name" :value="item.Exclusively_Id"
                                                           :key="index"></el-option>
                                            </el-select>
                                            <span>{{$t('getapi[1199]')}}</span>
                                            <el-select filterable v-model="formInline.Header.Vender_Property"
                                                       :disabled="formInline.Header.v_status == 1" class="mcolor w120">
                                                <el-option v-for="(items, index) in VenderProperty" :label="items.item"
                                                           :value="items.item" :key="index"></el-option>
                                            </el-select>
                                            <span>{{$t('getapi[6284]')}}</span>
                                            <el-select filterable v-model="formInline.Header.Grade_Id"
                                                       :disabled="formInline.Header.v_status == 1" class="mcolor w150">
                                                <el-option :label="$t('getapi[6085]')" value="0"></el-option>
                                                <el-option v-for="(item, index) in VenderGrade" :label="item.Grade_Name"
                                                           :value="item.Exclusively_ID" :key="index"></el-option>
                                            </el-select>
                                            <span>{{$t('getapi[1200]')}}</span>
                                            <el-input v-model="formInline.Header.Vender_Developer"
                                                      class="w150"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1242]')}}</span>
                                            <el-input v-model="formInline.Header.Legal_Person"
                                                      class="mcolor w120"></el-input>
                                            <span>{{$t('getapi[1241]')}}</span>
                                            <el-input v-model="formInline.Header.Contact_Person"
                                                      class="w120"></el-input>
                                            <span>{{$t('getapi[1202]')}}</span>
                                            <el-input v-model="formInline.Header.phone_number"
                                                      class="mcolor w150"></el-input>
                                            <span>{{$t('getapi[1203]')}}</span>
                                            <el-input v-model="formInline.Header.Fax_Number"
                                                      class="w150"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1207]')}}</span>
                                            <el-input v-model="formInline.Header.Mail_Address"
                                                      class="w120"></el-input>
                                            <span>{{$t('getapi[1205]')}}</span>
                                            <el-input v-model="formInline.Header.Contact_person_Post" class="w120"></el-input>
                                            <span>{{$t('getapi[548]')}}</span>
                                            <el-date-picker
                                                    v-model="formInline.Header.Effect_Date"
                                                    value-format="yyyy-MM-dd"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                                    class="mcolor w150"
                                            ></el-date-picker>
                                            <span>{{$t('getapi[549]')}}</span>
                                            <el-date-picker
                                                    v-model="formInline.Header.Invalid_Date"
                                                    value-format="yyyy-MM-dd"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                                    class="w150"
                                            ></el-date-picker>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1206]')}}</span>
                                            <el-input v-model="formInline.Header.Post_Code"
                                                      class="w120"></el-input>
                                            <span>{{$t('getapi[1243]')}}</span>
                                            <el-select filterable v-model="formInline.Header.Important_Level_Id"
                                                       :disabled="formInline.Header.v_status == 1" class="mcolor w120">
                                                <el-option :label="$t('getapi[6085]')" value="0"></el-option>
                                                <el-option
                                                        v-for="(item, index) in VenderImportant"
                                                        :label="item.Important_Level_name"
                                                        :value="item.Exclusively_Id"
                                                        :key="index"
                                                ></el-option>
                                            </el-select>
                                            <span>{{$t('getapi[6273]')}}</span>
                                            <el-input v-model="formInline.Header.limit_amount"
                                                      class="w150"></el-input>
                                            <span>{{$t('getapi[2587]')}}</span>
                                            <el-select filterable v-model="formInline.Header.Country" class="w150">
                                                <el-option v-for="(item, index) in Country" :label="item.englishName"
                                                           :value="item.englishName" :key="index"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[6453]')}}</span>
                                            <el-input v-model="formInline.Header.Vender_Address"
                                                      style="width: 335px; max-width: 1000px !important;"></el-input>
                                            <span>{{$t('getapi[2588]')}}</span>
                                            <el-select filterable v-model="formInline.Header.Area" class="w150">
                                                <el-option v-for="(item, index) in AreaS" :label="item.Area_Name"
                                                           :value="item.Area_Name" :key="index"></el-option>
                                            </el-select>
                                            <span>{{$t('getapi[1209]')}}</span>
                                            <el-input v-model="formInline.Header.Examination"
                                                      class="w150"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[410]')}}</span>
                                            <el-input v-model="formInline.Header.Create_person"
                                                      :readonly="true" class="readO" style="width:120px"></el-input>
                                            <span>{{$t('getapi[733]')}}</span>
                                            <el-input v-model="formInline.Header.Modify_person"
                                                      :readonly="true" class="readO" style="width:120px"></el-input>
                                            <span>{{$t('getapi[135]')}}</span>
                                            <el-input v-model="formInline.Header.Create_time"
                                                      :readonly="true" class="readO" style="width:150px"></el-input>
                                            <span>{{$t('getapi[1210]')}}</span>
                                            <el-input v-model="formInline.Header.Modify_time"
                                                      :readonly="true" class="readO" style="width:150px"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[4044]')}}</span>
                                            <el-input v-model="formInline.Header.Audit_Time"
                                                      :readonly="true" class="readO" style="width:120px"></el-input>
                                            <span>{{$t('getapi[1208]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.Supply_Products"
                                                    style="width: 330px !important; max-width: 1000px;"
                                            ></el-input>
                                            <span v-if="currencyCodeType == 1">{{$t('getapi[8085]')}}</span>
                                            <el-input v-model="formInline.Header.Certificate_Effect"
                                                       class="w150"
                                                      v-if="currencyCodeType == 1"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[6274]')}}</span>
                                            <el-checkbox :true-label="1" :false-label="0"
                                                         v-model="formInline.Header.login_vend"></el-checkbox>

                                            <span>{{$t('getapi[8086]')}}</span>
                                            <el-checkbox :true-label="1" :false-label="0"
                                                         v-model="formInline.Header.BatchPrice_Flag"></el-checkbox>
                                            &lt;!&ndash; <el-switch active-value="1" inactive-value="0" v-model="formInline.Header.login_vend" class="w120"></el-switch> &ndash;&gt;
                                            <span>{{$t('getapi[8506]')}}</span>
                                            <el-checkbox :true-label="1" :false-label="0"
                                                         v-model="formInline.Header.SendEmail_Flag"></el-checkbox>
                                        </div>
                                    </div>-->
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[184]')" v-if="btn.page_quality">
                                    <table>
                                        <tr>
                                            <td style="width:80px;min-width:80px"><span>{{$t('getapi[1212]')}}</span></td>
                                            <td style="width:300px;min-width:300px"><el-input v-model="formInline.Header.Certifications"
                                                                                              ></el-input></td>
                                        </tr>
                                        <tr>
                                            <td><span>{{$t('getapi[1218]')}}</span></td>
                                            <td><el-input v-model="formInline.Header.After_Service"
                                                          ></el-input></td>
                                        </tr>
                                        <tr>
                                            <td><span>{{$t('getapi[1213]')}}</span></td>
                                            <td><el-input v-model="formInline.Header.Product_Std"
                                            ></el-input></td>
                                        </tr>
                                        <tr>
                                            <td><span>{{$t('getapi[1216]')}}</span></td>
                                            <td><el-input v-model="formInline.Header.Protect_Method"
                                                         ></el-input></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <span>{{$t('getapi[1246]')}}</span>
                                                <el-checkbox v-model="formInline.Header.Quality_Ablity_FLAG">
                                                </el-checkbox>
                                                <span>{{$t('getapi[1215]')}}</span>
                                                <el-checkbox v-model="formInline.Header.isSelfStudy">
                                                </el-checkbox>
                                                <span>{{$t('getapi[1214]')}}</span>
                                                <el-checkbox v-model="formInline.Header.isHaveTechDept">
                                                </el-checkbox>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span>{{$t('getapi[1217]')}}</span></td>
                                            <td>
                                                <routejump :urlNo="22">
                                                <el-select filterable v-model="formInline.Header.Transport_Method"
                                                           class="mcolor">
                                                <el-option v-for="item in TransMode" :label="item.mode_name"
                                                           :value="item.mode_name"
                                                           :key="item.Exclusively_Id"></el-option>
                                            </el-select>
                                                </routejump></td>
                                        </tr>
                                        <tr>
                                            <td><span>{{$t('getapi[6276]')}}</span></td>
                                            <td>
                                                <el-input v-model="formInline.Header.with_days" onchange="value=parseInt(value)"
                                                          type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span>{{$t('getapi[143]')}}</span></td>
                                            <td><el-input type="textarea" v-model="formInline.Header.remark"></el-input></td>
                                        </tr>
                                    </table>
                                    <!--<div class="box">
                                        <div class="bbl">
                                            <span>{{$t('getapi[1212]')}}</span>
                                            <el-input v-model="formInline.Header.Certifications"
                                                      style="width:300px"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1218]')}}</span>
                                            <el-input v-model="formInline.Header.After_Service"
                                                      style="width:300px"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1213]')}}</span>
                                            <el-input v-model="formInline.Header.Product_Std"
                                                      style="width:300px"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1216]')}}</span>
                                            <el-input v-model="formInline.Header.Protect_Method"
                                                      style="width:300px"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1246]')}}</span>
                                            <el-checkbox v-model="formInline.Header.Quality_Ablity_FLAG">
                                            </el-checkbox>
                                            &lt;!&ndash;<el-switch v-model="formInline.Header.Quality_Ablity_FLAG"></el-switch>&ndash;&gt;
                                            <span>{{$t('getapi[1215]')}}</span>
                                            <el-checkbox v-model="formInline.Header.isSelfStudy">
                                            </el-checkbox>
                                            &lt;!&ndash;<el-switch v-model="formInline.Header.isSelfStudy"></el-switch>&ndash;&gt;
                                            <span>{{$t('getapi[1214]')}}</span>
                                            <el-checkbox v-model="formInline.Header.isHaveTechDept">
                                            </el-checkbox>
                                            &lt;!&ndash;<el-switch v-model="formInline.Header.isHaveTechDept"></el-switch>&ndash;&gt;
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1217]')}}</span>
                                            <el-select filterable v-model="formInline.Header.Transport_Method"
                                                       class="mcolor">
                                                <el-option v-for="item in TransMode" :label="item.mode_name"
                                                           :value="item.mode_name"
                                                           :key="item.Exclusively_Id"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[6276]')}}</span>
                                            <el-input v-model="formInline.Header.with_days" onchange="value=parseInt(value)"
                                                      type="number" @mousewheel.native.prevent style="width:300px"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[143]')}}</span>
                                            <el-input type="textarea" v-model="formInline.Header.remark" style="width:350px"></el-input>
                                        </div>
                                    </div>-->
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[1230]')" v-if="btn.page_cost">
                                    <div>
                                        <table>
                                            <tr>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6455]')}}</span></td>
                                                <td colspan="3"><el-input
                                                        v-model="formInline.Header.Bank_Account_Name"
                                                        size="mini"
                                                        style="width:300px"
                                                        :readonly="formInline.Header.v_status == 1"
                                                        :class="{'readO':formInline.Header.v_status == 1}"
                                                ></el-input></td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[1220]')}}</span></td>
                                                <td colspan="2"><el-input
                                                        v-model="formInline.Header.Bank_Account_Number"
                                                        size="mini"
                                                        style="width:300px"
                                                        :readonly="formInline.Header.v_status == 1"
                                                        :class="{'readO':formInline.Header.v_status == 1}"
                                                ></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1224]')}}</span></td>
                                                <td colspan="3"><el-input
                                                        v-model="formInline.Header.Tax_Number"
                                                        size="mini"
                                                        style="width:300px"
                                                        :readonly="formInline.Header.v_status == 1"
                                                        :class="{'readO':formInline.Header.v_status == 1}"
                                                ></el-input></td>
                                                <td><span>{{$t('getapi[6277]')}}</span></td>
                                                <td colspan="2"><el-input
                                                        v-model="formInline.Header.Electronics"
                                                        type="text"
                                                        style="width:300px"
                                                        size="mini"
                                                        :readonly="formInline.Header.v_status == 1"
                                                        :class="{'readO':formInline.Header.v_status == 1}"
                                                ></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1250]')}}</span></td>
                                                <td style="width:120px;min-width:120px"><el-input
                                                        class="mcolor"
                                                        v-model="formInline.Header.CheckOut_Cycle"
                                                        type="number"
                                                        autocomplete="off" title=""
                                                        @mousewheel.native.prevent
                                                        size="mini"
                                                ></el-input></td>
                                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[1082]')}}</span></td>
                                                <td style="width:120px;min-width:120px">
                                                    <routejump :urlNo="23">
                                                    <el-select class="mcolor" filterable v-model="formInline.Header.Payment_Way"
                                                               size="mini"
                                                               :disabled="formInline.Header.v_status==1?true:false"
                                                               style="width: 100%;">
                                                        <el-option
                                                                v-for="(item, index) in PaymentWay"
                                                                :label="item.Payment_Manner_Name"
                                                                :value="item.Payment_Manner_Name"
                                                                :key="index"
                                                        ></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td><span>{{$t('getapi[1227]')}}</span></td>
                                                <td style="wdth:200px;min-width:200px">
                                                    <routejump :urlNo="24">
                                                    <el-select class="mcolor" filterable
                                                               v-model="formInline.Header.Currency_Code" @change="cahngecurr"
                                                               :disabled="isEnabled" size="mini">
                                                        <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                                                   :value="item.currency_code" :key="index"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td style="wdth:120px;min-width:120px">
                                                    {{$t('getapi[946]')}}：{{ formInline.Header.Currency_zh }} {{$t('getapi[1223]')}}
                                                    <el-checkbox v-model="formInline.Header.tax_flag">
                                                    </el-checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1249]')}}</span></td>
                                                <td colspan="3">
                                                    <routejump :urlNo="25">
                                                    <el-select
                                                            class="mcolor"
                                                            filterable
                                                            v-model="formInline.Header.Tax_Code"
                                                            @change="cahngerate"
                                                            size="mini"
                                                            :disabled="isEnabled"
                                                            style="width: 100px;"
                                                    >
                                                        <el-option v-for="(item, index) in RateCode" :label="item.tax_code"
                                                                   :value="item.tax_code" :key="index"></el-option>
                                                    </el-select>
                                                        {{$t('getapi[1248]')}}{{ formInline.Header.Tax_rate }}%
                                                    </routejump>
                                                </td>
                                                <td><span>{{$t('getapi[1222]')}}</span></td>
                                                <td colspan="2">
                                                    <el-input
                                                            type="textarea"
                                                            v-model="formInline.Header.Payment_Clause"
                                                            style="width:400px"
                                                            size="mini"
                                                            :readonly="formInline.Header.v_status == 1"
                                                            :class="{'readO':formInline.Header.v_status == 1}"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1228]')}}</span></td>
                                                <td><el-select filterable v-model="formInline.Header.Balance_Mode"
                                                               class="mcolor">
                                                    <el-option v-for="(items, index) in BalanceMode" :label="items.item"
                                                               :value="items.item" :key="index"></el-option>
                                                </el-select></td>
                                                <td><span>{{$t('getapi[1229]')}}</span></td>
                                                <td><el-select filterable v-model="formInline.Header.delivery_term"
                                                               :disabled="formInline.Header.v_status == 1">
                                                    <el-option v-for="(items, index) in DeliveryTerm" :label="items.item"
                                                               :value="items.item" :key="index"></el-option>
                                                </el-select></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[6278]')}}</span></td>
                                                <td colspan="3">
                                                    <el-input
                                                            v-model="formInline.Header.cloud"
                                                            type="text"
                                                            size="mini"
                                                            :readonly="formInline.Header.v_status == 1"
                                                            :class="{'readO':formInline.Header.v_status == 1}"
                                                    ></el-input>
                                                </td>
                                                <td><span>{{$t('getapi[6280]')}}</span></td>
                                                <td colspan="2">
                                                    <el-input
                                                            v-model="formInline.Header.Ele_Bank"
                                                            type="text"
                                                            size="mini"
                                                            :readonly="formInline.Header.v_status == 1"
                                                            :class="{'readO':formInline.Header.v_status == 1}"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[6281]')}}</span></td>
                                                <td colspan="3">
                                                    <el-input v-model="formInline.Header.bank_addr"
                                                              type="text" size="mini"></el-input>
                                                </td>
                                                <td>
                                                    <span v-if="currencyCodeType == 1">{{$t('getapi[6279]')}}</span>
                                                    <span v-if="currencyCodeType == 2">Routing(ABA)</span>
                                                </td>
                                                <td colspan="2">
                                                    <el-input
                                                            v-model="formInline.Header.large_amount"
                                                            type="text"
                                                            size="mini"
                                                            :readonly="formInline.Header.v_status == 1"
                                                            :class="{'readO':formInline.Header.v_status == 1}"
                                                            v-if="currencyCodeType == 1"
                                                    ></el-input>
                                                    <el-input
                                                            v-model="formInline.Header.routing_aba"
                                                            placeholder="Routing(ABA)"
                                                            type="text"
                                                            size="mini"
                                                            v-if="currencyCodeType == 2"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{$t('getapi[1201]')}}</span></td>
                                                <td colspan="3">
                                                    <el-input v-model="formInline.Header.vender_addr"
                                                              type="text" size="mini"></el-input>
                                                </td>
                                                <td><span>{{$t('getapi[12854]')}}</span></td>
                                                <td colspan="3">
                                                    <el-input v-model="formInline.Header.OLBank_Account_Number" class="mcolor"
                                                              type="text" size="mini"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span v-if="currencyCodeType == 2">{{$t('getapi[6282]')}}</span></td>
                                                <td colspan="2">
                                                    <el-input v-model="formInline.Header.countrystate"
                                                              type="text" size="mini" v-if="currencyCodeType == 2"></el-input>
                                                </td>
                                                <td><span v-if="currencyCodeType == 2">Swift code</span></td>
                                                <td colspan="3">
                                                    <el-input v-model="formInline.Header.swift_aba" placeholder="Swift code"
                                                              type="text" size="mini" v-if="currencyCodeType == 2"></el-input>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <!--<div class="box">
                                        <div class="bbl">
                                            <span>{{$t('getapi[6455]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.Bank_Account_Name"
                                                    size="mini"
                                                    style="width:300px"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                            ></el-input>
                                            <span>{{$t('getapi[1220]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.Bank_Account_Number"
                                                    size="mini"
                                                    style="width:300px"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                            ></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1224]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.Tax_Number"
                                                    size="mini"
                                                    style="width:300px"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                            ></el-input>
                                            <span>{{$t('getapi[6277]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.Electronics"
                                                    type="text"
                                                    style="width:300px"
                                                    size="mini"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                            ></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1250]')}}</span>
                                            <el-input
                                                    class="mcolor"
                                                    v-model="formInline.Header.CheckOut_Cycle"
                                                    type="number"
                                                    @mousewheel.native.prevent
                                                    size="mini"
                                                    style="width: 100px;"
                                            ></el-input>
                                            <span>{{$t('getapi[1082]')}}</span>
                                            <el-select class="mcolor" filterable v-model="formInline.Header.Payment_Way"
                                                       size="mini"
                                                       :disabled="formInline.Header.v_status==1?true:false"
                                                       style="width: 100px;">
                                                <el-option
                                                        v-for="(item, index) in PaymentWay"
                                                        :label="item.Payment_Manner_Name"
                                                        :value="item.Payment_Manner_Name"
                                                        :key="index"
                                                ></el-option>
                                            </el-select>
                                            <span>{{$t('getapi[1227]')}}</span>
                                            <el-select class="mcolor" filterable
                                                       v-model="formInline.Header.Currency_Code" @change="cahngecurr"
                                                       :disabled="isEnabled" size="mini">
                                                <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                                           :value="item.currency_code" :key="index"></el-option>
                                            </el-select>
                                            {{$t('getapi[946]')}}：{{ formInline.Header.Currency_zh }} {{$t('getapi[1223]')}}
                                            <el-checkbox v-model="formInline.Header.tax_flag">
                                            </el-checkbox>
                                            &lt;!&ndash;<el-switch v-model="formInline.Header.tax_flag" size="mini"
                                                       :disabled="isEnabled"></el-switch>&ndash;&gt;
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1249]')}}</span>
                                            <el-select
                                                    class="mcolor"
                                                    filterable
                                                    v-model="formInline.Header.Tax_Code"
                                                    @change="cahngerate"
                                                    size="mini"
                                                    :disabled="isEnabled"
                                                    style="width: 100px;"
                                            >
                                                <el-option v-for="(item, index) in RateCode" :label="item.tax_code"
                                                           :value="item.tax_code" :key="index"></el-option>
                                            </el-select>
                                            &lt;!&ndash; <el-input v-model="formInline.Header.Tax_Code" placeholder="税代码" style="width:100px"></el-input> &ndash;&gt;
                                            {{$t('getapi[1248]')}}{{ formInline.Header.Tax_rate }}%
                                            <span>{{$t('getapi[1222]')}}</span>
                                            <el-input
                                                    type="textarea"
                                                    v-model="formInline.Header.Payment_Clause"
                                                    style="width:400px"
                                                    size="mini"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                            ></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1228]')}}</span>
                                            <el-select filterable v-model="formInline.Header.Balance_Mode"
                                                       class="mcolor w120">
                                                <el-option v-for="(items, index) in BalanceMode" :label="items.item"
                                                           :value="items.item" :key="index"></el-option>
                                            </el-select>
                                            <span>{{$t('getapi[1229]')}}</span>
                                            <el-select filterable v-model="formInline.Header.delivery_term"
                                                       :disabled="formInline.Header.v_status == 1">
                                                <el-option v-for="(items, index) in DeliveryTerm" :label="items.item"
                                                           :value="items.item" :key="index"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[6278]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.cloud"
                                                    type="text"
                                                    style="width:300px"
                                                    size="mini"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                            ></el-input>

                                            <span>{{$t('getapi[6280]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.Ele_Bank"
                                                    type="text"
                                                    style="width:300px"
                                                    size="mini"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                            ></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[6281]')}}</span>
                                            <el-input v-model="formInline.Header.bank_addr"
                                                      type="text" style="width:300px" size="mini"></el-input>

                                            <span v-if="currencyCodeType == 1">{{$t('getapi[6279]')}}</span>
                                            <el-input
                                                    v-model="formInline.Header.large_amount"
                                                    type="text"
                                                    style="width:300px"
                                                    size="mini"
                                                    :readonly="formInline.Header.v_status == 1"
                                                    :class="{'readO':formInline.Header.v_status == 1}"
                                                    v-if="currencyCodeType == 1"
                                            ></el-input>
                                            <span v-if="currencyCodeType == 2">Routing(ABA)</span>
                                            <el-input
                                                    v-model="formInline.Header.routing_aba"
                                                    placeholder="Routing(ABA)"
                                                    type="text"
                                                    style="width:300px"
                                                    size="mini"
                                                    v-if="currencyCodeType == 2"
                                            ></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span>{{$t('getapi[1201]')}}</span>
                                            <el-input v-model="formInline.Header.vender_addr"
                                                      type="text" style="width:300px" size="mini"></el-input>
                                            <span v-if="currencyCodeType == 2">{{$t('getapi[6282]')}}</span>
                                            <el-input v-model="formInline.Header.countrystate"
                                                      type="text" style="width:300px" size="mini" v-if="currencyCodeType == 2"></el-input>
                                        </div>
                                        <div class="bbl">
                                            <span v-if="currencyCodeType == 2">Swift code</span>
                                            <el-input v-model="formInline.Header.swift_aba" placeholder="Swift code"
                                                      type="text" style="width:300px" size="mini" v-if="currencyCodeType == 2"></el-input>
                                        </div>
                                    </div>-->
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[6421]')">
                                    <el-upload
                                            class="upload-demo"
                                            ref="upload"
                                            :action="uploadurl"
                                            :on-preview="handlePreview"
                                            :on-remove="handleRemove"
                                            :on-change="handleChange"
                                            :on-success="handleSuccess"
                                            :on-error="handleError"
                                            :before-upload="beforeAvatarUpload"
                                            :file-list="fileList3"
                                            :data="fileparm"
                                            :limit="1"
                                    >
                                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
                                        <div slot="tip" class="el-upload__tip"></div>
                                    </el-upload>
                                    <el-table
                                            :data="FileList"
                                            v-loading="loading"
                                            :highlight-current-row="false"
                                            show-overflow-tooltip="true"
                                            border
                                            stripe
                                            size="mini"
                                            header-row-class-name="headerclass"
                                    >
                                        <el-table-column show-overflow-tooltip prop="Node_Name"
                                                         :label="$t('getapi[3590]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Doc_Type"
                                                         :label="$t('getapi[6423]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Doc_Size"
                                                         :label="$t('getapi[7875]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Upload_Person"
                                                         :label="$t('getapi[6425]')"></el-table-column>
                                        <el-table-column show-overflow-tooltip prop="Upload_Time"
                                                         :label="$t('getapi[6426]')"></el-table-column>
                                        <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="open(scope)" type="text" size="mini">
                                                    {{ scope.row.operate }}
                                                </el-button>
                                                <el-button @click.native.prevent="filedel(scope)" type="text"
                                                           size="mini">{{ $t('getapi[40]') }}
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </el-form>
                    </el-col>
                </el-row>

                <!-- 编辑弹框 -->
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="SchVenderMasterViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[84]')" queryData="SchVenderMasterViewInfo" :tabNo="SelectIndex" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 		<el-dialog :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('getapi[2020]')">
                    <el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
                            <template slot-scope="scope">
                                <input type="text" v-model="scope.row.query_Condition" style="border:none" />
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
                <el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
                <el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
            </span>
        </el-dialog> -->
        <!-- 搜索弹框 -->
        <el-dialog v-dialogDrag :title="$t('getapi[1129]')" :visible.sync="isShowChangePwd" width="30%">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[1196]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataChangePwd.vender_code" :readonly="true" class="readO"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[3500]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataChangePwd.pwd" type="password" show-password></el-input>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="isShowChangePwd = false" size="mini">{{$t('getapi[2054]')}}</el-button>
                <el-button type="primary" @click="confirmChangePwd" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import urlpost from '@/api/config.js';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

    export default {
        name: 'suplist',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                tableHeader1: [],
                tableHeader2: [],
                FileList: [],
                formInline: {
                    FileList: {},
                    Header: {
                        insert_flag: true,
                        Vender_code: '',
                        Vender_Name: '',
                        sort_Id: '0',
                        Grade_Id: '0',
                        Important_Level_Id: '0',
                        Vender_Developer: '',
                        Vender_Address: '',
                        Legal_Person: '',
                        phone_number: '',
                        Fax_Number: '',
                        Contact_Person: '',
                        Contact_person_Post: '',
                        Post_Code: '',
                        Mail_Address: '',
                        Supply_Products: '',
                        Effect_Date: '',
                        Invalid_Date: '',
                        Examination: '',
                        v_status: 1,
                        vender_Status: '',
                        Remark: '',
                        Create_person: '',
                        Create_time: '',
                        Modify_person: '',
                        Modify_time: '',
                        Country: '',
                        Area: '',
                        cargo_position_code: '',
                        Vender_Property: '',
                        Audit_Person: '',
                        Audit_Time: '',
                        Login_Password: '',
                        Login_Flag: '',
                        login_times: '',
                        last_login_time: '',
                        Certificate_Effect: '',
                        limit_amount: '',
                        login_vend: 0,
                        Bank_Account_Name: '',
                        Bank_Account_Number: '',
                        CheckOut_Cycle: 0,
                        Payment_Way: '',
                        Payment_Clause: '',
                        tax_flag: true,
                        Tax_Number: '',
                        Tax_Code: '',
                        Tax_rate: '',
                        Financing_Type: '',
                        Currency_Code: '',
                        Currency_zh: '',
                        Balance_Mode: '月结',
                        Delivery_Term: 'E-Works',
                        Electronics: '',
                        cloud: '',
                        large_amount: '',
                        Ele_Bank: '',
                        bank_addr: '',
                        countrystate: '',
                        vender_addr: '',
                        swift_aba: '',
                        routing_aba: '',
                        Quality_Ablity_FLAG: true,
                        Certifications: '',
                        Product_Std: '',
                        isHaveTechDept: true,
                        isSelfStudy: true,
                        Protect_Method: '',
                        Transport_Method: '',
                        After_Service: '',
                        with_days: '0'
                        //type: []
                    }
                },
                oldFormInline: '',
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('suplist'),
                oldSelectIndex: 0,
                SelectIndex: 0,
                fileList3: [],
                fileparm: {
                    Code: '',
                    Doc_Detail: '',
                    Data_Type: 2,
                    flag: 1,
                    Type: 2, // 客户信息
                    Login_Group:'',
                    Login_DB:'',
                },
                uploadurl: '',
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: false, // 是否新增
                isEditVName: false, // 是否新增
                vendertypelist: [], //供应商类型
                VenderProperty: [], //供应商性质
                VenderGrade: [], //等级
                VenderImportant: [], //重要度
                Country: [], //国家
                AreaS: [], //地区
                TransMode: [], //运输方式
                Currency: [], //货币代码
                RateCode: [], //税代码
                DeliveryTerm: [], //交付条款
                BalanceMode: [], //结算方式
                PaymentWay: [], //付款方式
                currentRow: null,
                btn: {
                    //设为合供商
                    qualified: false,
                    ///设为被撤销
                    Unqualified: false,
                    ///设为待审核
                    QuoEnable: false,
                    ///解除最小采购金额
                    LimitAmount: false,
                    //质量相关
                    page_quality: false,
                    //财务相关
                    page_cost: false
                },
                //检测某供应商是否有PO
                IsExistPO: {
                    OtherValue: 0
                },
                //是否含税、货币代码、税代码是否可以编辑
                isEnabled: false, // 是否可操作
                //供应商主键唯一键
                Vender_code: "",
                VenderCode: '',
                currencyCodeType: 1, // 1:境内2：境外
                oldrow: '',
                iscontinuedblclick: true,
                activeName: '0', // 当前选择的分页
                isShowChangePwd: false,
                dataChangePwd: {
                    vender_code: '',
                    pwd: ''
                },
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        create() {
            this.getselect();
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            // that.uploadurl = Common.Url + 'Basic/UploadFileByDocManage?token=' + token;
            that.uploadurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            that.getqwlist();
            that.getselect();
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('suplist', that)
            that.oldFormInline = JSON.stringify(that.formInline)
            that.confirmAdd();
            that.$limits.dragControllerDiv();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })

        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SchVenderMasterViewInfo', that.SelectIndex, PFileds => {
                    if(that.SelectIndex==0){
                        that.tableHeader=PFileds;
                    }
                    else if(that.SelectIndex==1){
                        that.tableHeader1=PFileds;
                    }
                    else if(that.SelectIndex==2){
                        that.tableHeader2=PFileds;
                    }
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[84]"),this.$t("getapi[17]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 47, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 46, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 47, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 47, 1) == 2) {
                        if (that.$limits.authority('plv3', 47, 1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 47, 1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.formInline.Header.Vender_code)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 47, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.formInline.Header.Vender_code)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                that.$refs.SetBtn.InputBtnRight('T04_VenderMaster');
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                  if (that.formInline.Header.v_status == 3) {
                    that.isEditVName = true;
                }
                if (that.formInline.Header.v_status == 1) {
                    that.isEditVName = true;
                }
                if (that.formInline.Header.v_status == 2) {
                    that.isEditVName  = false;
                }
            

                console.log("测试权限：" + that.IsExistPO.OtherValue);
                if (that.IsExistPO.OtherValue == 1) {
                    that.isEnabled = true;
                } else {
                    that.isEnabled = false;
                }
                //设为合供商
                that.btn.qualified = true;
                ///设为被撤销
                that.btn.Unqualified = true;
                ///设为待审核
                that.btn.QuoEnable = true;
                ///解除最小采购金额
                that.btn.LimitAmount = false;
                //质量相关
                that.btn.page_quality = false;
                //财务相关
                that.btn.page_cost = false;
                if (that.$limits.authority('plv4', 12, 1) > 0) {
                    that.btn.page_quality = true;
                }
                if (that.$limits.authority('plv4', 13, 1) > 0) {
                    that.btn.page_cost = true;
                }

                if (that.$limits.fnIsEmpty(that.formInline.Header.Vender_code)) {
                    //设为合供商
                    that.btn.qualified = false;
                    ///设为被撤销
                    that.btn.Unqualified = false;
                    ///设为待审核
                    that.btn.QuoEnable = false;
                    return;
                }
                if (!that.$limits.fnIsEmpty(that.formInline.Header.Vender_code)) {
                    if (that.$limits.authority('plv3', 47, 1) > 0) {
                        //操作级
                        that.btn.LimitAmount = true;
                        //////////////////////////////////////////////////////////////////////////////////////（设为合供商）
                        if (that.$limits.authority('plv4', 14, 1) == 0) {
                            //不可用（设为合供商）
                            that.btn.qualified = false;
                        }
                        // console.log('供应商状态:' + that.formInline.Header.vender_Status);
                        if (that.$limits.authority('plv4', 14, 1) == 1) {
                            //可用（设为合供商）
                            if (that.formInline.Header.v_status == 3) {
                                that.btn.qualified = true;
                            }
                            if (that.formInline.Header.v_status == 1) {
                                that.btn.qualified = false;
                            }
                            if (that.formInline.Header.v_status == 2) {
                                that.btn.qualified = true;
                            }
                        }
                        if (that.$limits.authority('plv4', 15, 1) == 0) {
                            //不可用（设为被撤销）
                            that.btn.Unqualified = false;
                        }
                        if (that.$limits.authority('plv4', 15, 1) == 1) {
                            //可用（设为被撤销）
                            if (that.formInline.Header.v_status == 3) {
                                that.btn.Unqualified = true;
                            }
                            if (that.formInline.Header.v_status == 1) {
                                that.btn.Unqualified = true;
                            }
                            if (that.formInline.Header.v_status == 2) {
                                that.btn.Unqualified = false;
                            }
                        }
                        if (that.$limits.authority('plv4', 16, 1) == 0) {
                            //不可用（设为待审核）
                            that.btn.QuoEnable = false;
                        }
                        if (that.$limits.authority('plv4', 16, 1) == 1) {
                            //可用（设为待审核）
                            if (that.formInline.Header.v_status == 3) {
                                that.btn.QuoEnable = false;
                            }
                            if (that.formInline.Header.v_status == 1) {
                                that.btn.QuoEnable = true;
                            }
                            if (that.formInline.Header.v_status == 2) {
                                that.btn.QuoEnable = true;
                            }
                        }
                    }
                }
            },
            tableRowClassName({row, rowIndex}) {
                if(row.v_status != 1){
                    return 'gray'
                }
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('suplist',val)
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //if (item.query_Condition == '' || item.query_Condition.length > 0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //}
                });
                console.log(parm);
                that.$http.urlpost('VenderInfoView', parm, function (res) {
                    // console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.loading = false;
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            // 保存数据
            save() {
                let that = this;
                if(that.formInline.Header.Vender_code == ''){
                    that.$message.warning(that.$t('getapi[1252]'))//供应商代码不能为空
                    return
                }
                if(that.formInline.Header.Balance_Mode == ''){
                    that.$message.warning(that.$t('getapi[1253]'))//'财务相关中,结算方式不能为空'
                    return
                }
                if(that.formInline.Header.sort_Id == ''){
                    that.$message.warning(that.$t('getapi[1254]'))//'供应商类型不能为空'
                    return
                }
                if(that.formInline.Header.Vender_Property == ''){
                    that.$message.warning(that.$t('getapi[1255]'))//'供应商性质不能为空'
                    return
                }
                // if(that.formInline.Header.Contact_Person == ''){
                //     that.$message.warning('联系人名称不能为空')
                //     return
                // }
                if(that.formInline.Header.phone_number == ''){
                    that.$message.warning(that.$t('getapi[1257]'))//'联系人电话不能为空'
                    return
                }
                if(that.formInline.Header.CheckOut_Cycle === ""){
                    that.$message.warning(that.$t('getapi[1258]'))//'结算周期不能为空'
                    return
                }
                if(that.formInline.Header.Effect_Date == ''){
                    that.$message.warning(that.$t('getapi[1259]'))//'生效日期不能为空'
                    return
                }
                if(that.formInline.Header.Tax_rate === ""){
                    that.$message.warning(that.$t('getapi[1260]'))//'供应商税率不能为空'
                    return
                }
                if(that.formInline.Header.Currency_Code == ''){
                    that.$message.warning(that.$t('getapi[1261]'))//'货币代码不能为空'
                    return
                }
                if(that.formInline.Header.Bank_Account_Name == ''){
                    that.$message.warning(that.$t('getapi[8809]'))//'开户银行不能为空'
                    return
                }
                if(that.formInline.Header.Bank_Account_Number == ''){
                    that.$message.warning(that.$t('getapi[8810]'))//'银行账号不能为空'
                    return
                }
                if(that.formInline.Header.Payment_Way == ''){
                    that.$message.warning(that.$t('getapi[8811]'))//'付款方式不能为空'
                    return
                }
                if(that.formInline.Header.Effect_Date != '' && that.formInline.Header.Effect_Date != null  && that.formInline.Header.Invalid_Date != ''  && that.formInline.Header.Invalid_Date != null){
                    if(new Date(that.formInline.Header.Effect_Date) >= new Date(that.formInline.Header.Invalid_Date)){
                        that.$message.warning(that.$t('getapi[1268]'))//'生效日期要小于失效日期'
                        return
                    }
                }
                if(that.formInline.Header.with_days < 0){
                    that.$message.warning(that.$t('getapi[8812]'))//'合并下单天数必须大于零'
                    return
                }
                if(that.formInline.Header.delivery_term == ''){
                    that.$message.warning(that.$t('getapi[1269]'))//'交付条款不能为空'
                    return
                }
                if(that.formInline.Header.Transport_Method == ''){
                    that.$message.warning(that.$t('getapi[1270]'))//'运输方式不能为空'
                    return
                }
                if(that.formInline.Header.Currency_Code == 'CNY' && that.formInline.Header.OLBank_Account_Number == ''){
                    that.$message.warning(that.$t('getapi[12855]'))//'网银开户行号不能为空'
                    return
                }
                if(that.formInline.Header.Currency_Code != 'CNY'){
                    if(that.formInline.Header.bank_addr == ''){
                        that.$message.warning(that.$t('getapi[8813]'))//'开户银行地址不能为空'
                        return
                    }
                    if(that.formInline.Header.countrystate == ''){
                        that.$message.warning(that.$t('getapi[8814]'))//'供应商国别不能为空'
                        return
                    }
                    if(that.formInline.Header.vender_addr == ''){
                        that.$message.warning(that.$t('getapi[8815]'))//'供应商地址不能为空'
                        return
                    }
                    if(that.formInline.Header.swift_aba == '' && that.formInline.Header.routing_aba == ''){
                        that.$message.warning(that.$t('getapi[8816]'))//'Swift code或Routing(ABA)至少填写一项'
                        return
                    }
                } else {
                    if(that.formInline.Header.limit_amount < 0){
                        that.$message.warning(that.$t('getapi[8817]'))//'最小采购金额必须大于0'
                        return
                    }
                    if(that.formInline.Header.Tax_Number == ''){
                        that.$message.warning(that.$t('getapi[8818]'))//'税号不能为空'
                        return
                    }
                    if(that.formInline.Header.large_amount == ''){
                        that.$message.warning(that.$t('getapi[8819]'))//'电子承兑大额行号不能为空'
                        return
                    }
                    if(that.formInline.Header.Certificate_Effect == ''){
                        that.$message.warning(that.$t('getapi[8820]'))//'三证合一有效期不能为空'
                        return
                    }
                }
                let parm = that.formInline.Header;
                that.loading = true;
                // console.log(JSON.stringify(parm));
                that.$http.urlpost('VenderInfoSave', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        // parm.Vender_code = res.UniqueNum;
                        that.getdetail(res.UniqueNum);
                        that.VenderCode = res.UniqueNum;
                        that.loading = false;
                        that.editvisi = false;
                    } else {
                        that.loading = false;
                    }
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },
            // 编辑
            edit(jsd) {
                console.log(jsd);
                //this.formInline = jsd.row;
                //this.formInline.Header.insert_flag = false;
                this.isEdit = true;
                this.VenderCode = jsd.row.Vender_code;
                this.getdetail(jsd.row.Vender_code);
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
                console.log(that.selectIDData);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('Basic/Items/BatchDeleteWorkCenter', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[659]'));
                        that.datajson.forEach(function (item, index) {
                            if (that.ids.indexOf(item.Exclusively_Id) >= 0) {
                                that.datajson.splice(index, 1);
                            }
                        });
                    }
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this;
                if (that.oldFormInline != JSON.stringify(that.formInline)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this
                that.formInlines = {
                    Vender_code: '',
                    Vender_Name: '',
                    sort_Id: '0',
                    Grade_Id: '0',
                    Important_Level_Id: '0',
                    Vender_Developer: '',
                    Vender_Address: '',
                    Legal_Person: '',
                    phone_number: '',
                    Fax_Number: '',
                    Contact_Person: '',
                    Contact_person_Post: '',
                    Post_Code: '',
                    Mail_Address: '',
                    Supply_Products: '',
                    Effect_Date: '',
                    Invalid_Date: '',
                    Examination: '',
                    v_status:'',
                    vender_Status: '',
                    Remark: '',
                    Create_person: '',
                    Create_time: '',
                    Modify_person: '',
                    Modify_time: '',
                    Country: '',
                    Area: '',
                    cargo_position_code: '',
                    Vender_Property: '',
                    Audit_Person: '',
                    Audit_Time: '',
                    Login_Password: '',
                    Login_Flag: '',
                    login_times: '',
                    last_login_time: '',
                    Certificate_Effect: '',
                    limit_amount: '',
                    login_vend: 0,
                    Bank_Account_Name: '',
                    Bank_Account_Number: '',
                    CheckOut_Cycle: 0,
                    Payment_Way: '',
                    Payment_Clause: '',
                    tax_flag: true,
                    Tax_Number: '',
                    Tax_Code: '',
                    Financing_Type: '',
                    Currency_Code: '',
                    Balance_Mode: '月结',
                    delivery_term: 'E-Works',
                    Electronics: '',
                    cloud: '',
                    large_amount: '',
                    Ele_Bank: '',
                    bank_addr: '',
                    countrystate: '',
                    vender_addr: '',
                    swift_aba: '',
                    routing_aba: '',
                    Quality_Ablity_FLAG: true,
                    Certifications: '',
                    Product_Std: '',
                    isHaveTechDept: true,
                    isSelfStudy: true,
                    Protect_Method: '',
                    Transport_Method: '',
                    After_Service: '',
                    with_days: '',
                    OLBank_Account_Number:'',
                    vender_agent_date:'',
                    SceneAudit_Flag:0,
                    HC_Flag:0,
                    YearPE_Flag:0,
                    AVL_Flag:0,
                    IS_Flag:0,
                };
                that.formInline = {
                    FileList: {},
                    Header: {
                        insert_flag: true,
                        Vender_code: '',
                        Vender_Name: '',
                        sort_Id: '0',
                        Grade_Id: '0',
                        Important_Level_Id: '0',
                        Vender_Developer: '',
                        Vender_Address: '',
                        Legal_Person: '',
                        phone_number: '',
                        Fax_Number: '',
                        Contact_Person: '',
                        Contact_person_Post: '',
                        Post_Code: '',
                        Mail_Address: '',
                        Supply_Products: '',
                        Effect_Date: '',
                        Invalid_Date: '',
                        Examination: '',
                        v_status:'',
                        vender_Status: '',
                        Remark: '',
                        Create_person: '',
                        Create_time: '',
                        Modify_person: '',
                        Modify_time: '',
                        Country: '',
                        Area: '',
                        cargo_position_code: '',
                        Vender_Property: '',
                        Audit_Person: '',
                        Audit_Time: '',
                        Login_Password: '',
                        Login_Flag: '',
                        login_times: '',
                        last_login_time: '',
                        Certificate_Effect: '',
                        limit_amount: '',
                        login_vend: 0,
                        Bank_Account_Name: '',
                        Bank_Account_Number: '',
                        CheckOut_Cycle: 0,
                        Payment_Way: '',
                        Payment_Clause: '',
                        tax_flag: true,
                        Tax_Number: '',
                        Tax_Code: '',
                        Tax_rate: '',
                        Financing_Type: '',
                        Currency_Code: '',
                        Currency_zh: '',
                        Balance_Mode: '月结',
                        Delivery_Term: 'E-Works',
                        Electronics: '',
                        cloud: '',
                        large_amount: '',
                        Ele_Bank: '',
                        bank_addr: '',
                        countrystate: '',
                        vender_addr: '',
                        swift_aba: '',
                        routing_aba: '',
                        Quality_Ablity_FLAG: true,
                        Certifications: '',
                        Product_Std: '',
                        isHaveTechDept: true,
                        isSelfStudy: true,
                        Protect_Method: '',
                        Transport_Method: '',
                        After_Service: '',
                        with_days: '0',//合并下单天数
                        BatchPrice_Flag: 0,
                        SendEmail_Flag: 0,
                        OLBank_Account_Number:'',
                        vender_agent_date:'',
                        SceneAudit_Flag:0,
                        HC_Flag:0,
                        YearPE_Flag:0,
                        AVL_Flag:0,
                        IS_Flag:0,
                    }
                };
                this.editvisi = true;
                this.isEdit = false;
                this.IsExistPO.OtherValue = 0;
                this.VenderCode = "";
                that.oldFormInline = JSON.stringify(that.formInline)
                this.authority();
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SchVenderMasterViewInfo');
            },
            // 刷新
            reflash() {
                /*this.intidata();
                if(!this.$limits.fnIsEmpty(this.VenderCode))
                {
                this.getdetail(this.VenderCode);
                }*/
                let that = this;
                if (that.oldDataDetail != JSON.stringify(that.dataDetail)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            this.intidata();
                            if (!this.$limits.fnIsEmpty(this.VenderCode)) {
                                this.getdetail(this.VenderCode);
                            }
                        });
                } else {
                    this.intidata();
                    if (!this.$limits.fnIsEmpty(this.VenderCode)) {
                        this.getdetail(this.VenderCode);
                    }
                }
            },
            //导入
            imp() {
                let item = {
                    //label: '供应商导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/6',
                    url: '/exp/6',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/6'});
                this.$store.commit('selectMenu', item);
            },
            //导出·
            exps() {
                /*let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //if (item.query_Condition == '' || item.query_Condition.length > 0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //}
                });
                console.log(parm);
                that.$http.urlpost('ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                let fname = ''
                if(that.SelectIndex == 0){
                    fname = that.$t('getapi[3608]')
                } else if(that.SelectIndex == 1){
                    fname = that.$t('getapi[184]')
                } else if(that.SelectIndex == 2){
                    fname = that.$t('getapi[1230]')
                }
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SchVenderMasterViewInfo",
                    fromname: fname,
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            //操作按钮
            stat(e) {
                let parm = {
                    IID: '',
                    Code: typeof this.formInline.Header.Vender_code == 'undefined' ? '' : this.formInline.Header.Vender_code,
                    Name: typeof this.formInline.Header.Vender_Name == 'undefined' ? '' : this.formInline.Header.Vender_Name
                };
                let that = this;
                let sta = '合格供应商';
                if (e == 0) {
                    if(that.formInline.Header.Vender_code == ''){
                        that.$message.warning(that.$t('getapi[1252]'))//供应商代码不能为空
                        return
                    }
                    if(that.formInline.Header.Balance_Mode == ''){
                        that.$message.warning(that.$t('getapi[1253]'))//'财务相关中,结算方式不能为空'
                        return
                    }
                    if(that.formInline.Header.sort_Id == ''){
                        that.$message.warning(that.$t('getapi[1254]'))//'供应商类型不能为空'
                        return
                    }
                    if(that.formInline.Header.Vender_Property == ''){
                        that.$message.warning(that.$t('getapi[1255]'))//'供应商性质不能为空'
                        return
                    }
                    // if(that.formInline.Header.Contact_Person == ''){
                    //     that.$message.warning('联系人名称不能为空')
                    //     return
                    // }
                    if(that.formInline.Header.phone_number == ''){
                        that.$message.warning(that.$t('getapi[1257]'))//'联系人电话不能为空'
                        return
                    }
                    if(that.formInline.Header.CheckOut_Cycle === ""){
                        that.$message.warning(that.$t('getapi[1258]'))//'结算周期不能为空'
                        return
                    }
                    if(that.formInline.Header.Effect_Date == ''){
                        that.$message.warning(that.$t('getapi[1259]'))//'生效日期不能为空'
                        return
                    }
                    if(that.formInline.Header.Tax_rate === ""){
                        that.$message.warning(that.$t('getapi[1260]'))//'供应商税率不能为空'
                        return
                    }
                    if(that.formInline.Header.Currency_Code == ''){
                        that.$message.warning(that.$t('getapi[1261]'))//'货币代码不能为空'
                        return
                    }
                    if(that.formInline.Header.Bank_Account_Name == ''){
                        that.$message.warning(that.$t('getapi[8809]'))//'开户银行不能为空'
                        return
                    }
                    if(that.formInline.Header.Bank_Account_Number == ''){
                        that.$message.warning(that.$t('getapi[8810]'))//'银行账号不能为空'
                        return
                    }
                    if(that.formInline.Header.Payment_Way == ''){
                        that.$message.warning(that.$t('getapi[8811]'))//'付款方式不能为空'
                        return
                    }
                    if(that.formInline.Header.Effect_Date != '' && that.formInline.Header.Effect_Date != null  && that.formInline.Header.Invalid_Date != ''  && that.formInline.Header.Invalid_Date != null){
                        if(new Date(that.formInline.Header.Effect_Date) >= new Date(that.formInline.Header.Invalid_Date)){
                            that.$message.warning(that.$t('getapi[1268]'))//'生效日期要小于失效日期'
                            return
                        }
                    }
                    if(that.formInline.Header.with_days < 0){
                        that.$message.warning(that.$t('getapi[8812]'))//'合并下单天数必须大于零'
                        return
                    }
                    if(that.formInline.Header.delivery_term == ''){
                        that.$message.warning(that.$t('getapi[1269]'))//'交付条款不能为空'
                        return
                    }
                    if(that.formInline.Header.Transport_Method == ''){
                        that.$message.warning(that.$t('getapi[1270]'))//'运输方式不能为空'
                        return
                    }
                    if(that.formInline.Header.Currency_Code == 'CNY' && that.formInline.Header.OLBank_Account_Number == ''){
                        that.$message.warning(that.$t('getapi[12855]'))//'网银开户行号不能为空'
                        return
                    }
                    if(that.formInline.Header.Currency_Code != 'CNY'){
                        if(that.formInline.Header.bank_addr == ''){
                            that.$message.warning(that.$t('getapi[8813]'))//'开户银行地址不能为空'
                            return
                        }
                        if(that.formInline.Header.countrystate == ''){
                            that.$message.warning(that.$t('getapi[8814]'))//'供应商国别不能为空'
                            return
                        }
                        if(that.formInline.Header.vender_addr == ''){
                            that.$message.warning(that.$t('getapi[8815]'))//'供应商地址不能为空'
                            return
                        }
                        if(that.formInline.Header.swift_aba == '' && that.formInline.Header.routing_aba == ''){
                            that.$message.warning(that.$t('getapi[8816]'))//'Swift code或Routing(ABA)至少填写一项'
                            return
                        }
                    } else {
                        if(that.formInline.Header.limit_amount < 0){
                            that.$message.warning(that.$t('getapi[8817]'))//'最小采购金额必须大于0'
                            return
                        }
                        if(that.formInline.Header.Tax_Number == ''){
                            that.$message.warning(that.$t('getapi[8818]'))//'税号不能为空'
                            return
                        }
                        if(that.formInline.Header.large_amount == ''){
                            that.$message.warning(that.$t('getapi[8819]'))//'电子承兑大额行号不能为空'
                            return
                        }
                        if(that.formInline.Header.Certificate_Effect == ''){
                            that.$message.warning(that.$t('getapi[8820]'))//'三证合一有效期不能为空'
                            return
                        }
                    }
                    sta = '合格供应商';
                    parm.Status = sta;
                } else if (e == 1) {
                    sta = '被撤销';
                    parm.Status = sta;
                    that.$http.urlpost('UpdateQuoEnable', parm, function (res) {
                        if (res.Success == 1) {
                            // that.$message.success('设置价表无效成功');
                            that.getdetail(res.UniqueNum);
                        }
                    });
                } else if (e == 2) {
                    sta = '待审核';
                    parm.Status = sta;
                }
                console.log(parm);
                if (e < 3) {
                    that.$http.urlpost('VenderInfoStatus', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[1281]'));//'改变供应商状态成功'
                            if (e == 1)
                                that.VenderCode = res.UniqueNum;
                            that.getdetail(res.UniqueNum);
                        }
                    });
                } else {
                    that.$http.urlpost('UpdateLimitAmount', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[1406]'));//'解除成功'
                            that.VenderCode = res.UniqueNum;
                            that.getdetail(res.UniqueNum);
                        }
                    });
                }

                that.btnauthority();
            },
            //税率
            cahngerate(itm) {
                this.RateCode.forEach(item => {
                    if (item.tax_code == itm) {
                        this.formInline.Header.Tax_rate = item.tax_rate;
                    }
                });
            },
            //货币代码
            cahngecurr(itm) {
                let that = this
                if(itm == 'CNY'){
                    that.currencyCodeType = 1
                    that.formInline.Header.routing_aba  = ''
                    that.formInline.Header.countrystate  = ''
                    that.formInline.Header.swift_aba  = ''
                } else {
                    that.currencyCodeType = 2
                    that.formInline.Header.Certificate_Effect = ''
                    that.formInline.Header.large_amount = ''
                }
                this.Currency.forEach(item => {
                    if (item.currency_code == itm) {
                        this.formInline.Header.Currency_zh = item.description;
                    }
                });
            },
            // 获取详情
            getdetail(VenderCode) {
                let that = this;
                let parm = {
                    IID: '',
                    Code: VenderCode,
                    Name: '',
                    Status: ''
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('VenderInfoDetail', parm, function (res) {
                    if (res.Success == 1) {
                        that.formInline.Header = res.DataContent.Header[0];
                        that.VenderCode = that.formInline.Header.Vender_code;
                        that.FileList = res.DataContent.FileList;
                        that.IsExistPO = res.DataContent.Other[0];
                        that.cahngerate(res.DataContent.Header[0].Tax_Code);
                        that.cahngecurr(res.DataContent.Header[0].Currency_Code);
                        // console.log(that.formInline);
                        that.oldFormInline = JSON.stringify(that.formInline)
                        that.authority();
                        // that.btnauthority();
                    }
                    loadingInstance.close()
                });
                that.editvisi = true;
            },
            currency(value, currency, decimals) {
                const digitsRE = /(\d{3})(?=\d)/g;
                value = parseFloat(value);
                if (!isFinite(value) || (!value && value !== 0)) return '';
                currency = currency != null ? currency : '$';
                decimals = decimals != null ? decimals : 2;
                var stringified = Math.abs(value).toFixed(decimals);
                var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
                var i = _int.length % 3;
                var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
                var _float = decimals ? stringified.slice(-1 - decimals) : '';
                var sign = value < 0 ? '-' : '';
                return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
            },
            //获取下拉数据
            getselect() {
                let that = this;
                let parm = {};
                // 供应商类型
                // "Exclusively_Id": 15,
                // "sort_Name": "MRO",
                // "Alias_Name": "MRO",
                // "Description": "维修保养和其他",
                // "Remark": null
                that.$http.urlpost('VenderTypeSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.vendertypelist = res.DataContent;
                    }
                });
                /* 供应商性质
                  "currency_code": "CNY",
                  "description": "人民币元",
                  "currency_sign": "￥" */
                that.$http.urlpost('VenderPropertySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.VenderProperty = res.DataContent;
                    }
                });

                /* 	等级
                 "Exclusively_ID": 1,
                 "Grade_Name": "A级",
                 "Alias_Name": "A",
                 "Description": null,
                 "Remark": "对产品的性能，品质有重要影响的，对客户指定的物质等产品，如钣金件，机加工件等" */
                that.$http.urlpost('VenderGradeSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.VenderGrade = res.DataContent;
                    }
                });
                // 重要度
                //  "Exclusively_Id": 4,
                //       "Important_Level_name": "测试客户重要度",
                //       "Alias_Name": "Tzyd",
                //       "Description": null,
                //       "Remark": null
                that.$http.urlpost('VenderImportantSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.VenderImportant = res.DataContent;
                    }
                });
                // 国家
                //   "Exclusively_id": 1,
                //       "englishName": "China",
                //       "chineseName": "中国",
                //       "remark": null
                that.$http.urlpost('CountrySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.Country = res.DataContent;
                    }
                });
                // 地区
                // "num": 1,
                //       "Area_Name": "常州",
                //       "ShortName": "CZ",
                //       "Description": null,
                //       "Remarks": null
                that.$http.urlpost('AreaSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.AreaS = res.DataContent;
                    }
                });
                //运输方式
                // "Exclusively_id": 2,
                //      "mode_name": "海运",
                //      "remark": null
                that.$http.urlpost('TransModeSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.TransMode = res.DataContent;
                    }
                });
                // 货币代码
                // "currency_code": "CNY",
                //     "description": "人民币元",
                //     "currency_sign": "￥"
                that.$http.urlpost('CurrencySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.Currency = res.DataContent;
                    }
                });
                // 付款方式
                // "num": 1,
                //     "Payment_Manner_Name": "电汇",
                //     "ShortName": "DH",
                //     "Description": null,
                //     "Remarks": null
                that.$http.urlpost('PaymentWaySource', parm, function (res) {
                    if (res.Success == 1) {
                        that.PaymentWay = res.DataContent;
                    }
                });

                // 税代码
                // "Exclusively_ID": 5,
                //    "tax_code": "GY",
                //    "tax_rate": 6,
                //    "Remark": null
                that.$http.urlpost('RateCodeSource', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        console.log('税代码:' + JSON.stringify(res.DataContent));
                        that.RateCode = res.DataContent;
                    }
                });
                // 结算方式
                // "item": "票到"
                that.$http.urlpost('BalanceModeSource', parm, function (res) {
                    if (res.Success == 1) {
                        // console.log('结算方式:' + JSON.stringify(res.DataContent));
                        that.BalanceMode = res.DataContent;
                    }
                });
                // 交付条款
                // "item": "E-Works"
                that.$http.urlpost('DeliveryTermSource', parm, function (res) {
                    if (res.Success == 1) {
                        // console.log('交付条款:' + JSON.stringify(res.DataContent));
                        that.DeliveryTerm = res.DataContent;
                    }
                });
            },
            //删除文件
            filedel(row) {
                let that = this;
                let index = row.$index;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                                that.FileList.splice(index, 1);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //打开文件
            open(row) {
                let that = this;
               
                // if (!that.$limits.fnIsEmpty(row.row.FileSrc)) {
                //     window.open(Common.Url + row.row.FileSrc);
                // }

                 const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            handleChange(file, fileList) {
                let that = this;
                console.log('------handleChange---', file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        //
                        // that.datajson = file.response.DataContent;
                    }
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.getdetail(that.formInline.Header.Vender_code);
                    that.$refs.upload.clearFiles();
                    // 后台没有返回数据
                    //that.FileList = res.DataContent.FileList;
                    // that.FileList.push({Node_Name:'',Doc_Type:'',Doc_Size:'',Upload_Person,'',Upload_Time''})
                    //that.datajson = res.DataContent;
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                let that = this;
                that.fileparm.Code = that.formInline.Header.Vender_code;
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                console.log('---handlePreview--', that.fileparm);
                console.log(file);
            },
            beforeAvatarUpload(file) {
                let that = this;
                that.fileparm.Code = that.formInline.Header.Vender_code;
                if (that.formInline.Header.Vender_code == '' || that.formInline.Header.Vender_code == null) {
                    that.$message.error(that.$t('getapi[8787]'));//'必须填写客户代码后才能上传文件'
                    return false;
                }
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                return true;
            },
            selectInfo(tab){
                let that = this
                that.activeName = tab.name
                that.SelectIndex = tab.name
                that.colsort();
                that.$nextTick(function(){
                    setTimeout(() => {
                        that.$processdata.initForm(tab.name)
                    }, 500);
                });
            },
            edits(jsd) {
                let that = this
                if(that.VenderCode == jsd.Vender_code){
                    return
                }
                that.timeId = setTimeout(() => {
                    if (that.oldFormInline != JSON.stringify(that.formInline)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.oldSelectIndex = that.activeName
                                that.iscontinuedblclick = true
                                that.VenderCode = jsd.Vender_code;
                                that.oldrow = jsd
                                this.isEdit = true;
                                if (jsd.Currency_Code.toUpperCase() == 'CNY') {
                                    that.currencyCodeType = 1
                                } else {
                                    that.currencyCodeType = 2
                                }
                                that.getdetail(jsd.Vender_code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if(that.oldSelectIndex == 0){
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if(that.oldSelectIndex == 1){
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if(that.oldSelectIndex == 2){
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                                that.activeName = that.oldSelectIndex
                            });
                    } else {
                        that.oldSelectIndex = that.activeName
                        that.iscontinuedblclick = true
                        that.VenderCode = jsd.Vender_code;
                        that.oldrow = jsd
                        this.isEdit = true;
                        if (jsd.Currency_Code.toUpperCase() == 'CNY') {
                            that.currencyCodeType = 1
                        } else {
                            that.currencyCodeType = 2
                        }
                        that.getdetail(jsd.Vender_code);
                    }
                }, 100);
            },
            //拖动条中间快捷按钮
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            //点击键盘触发
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            //按住键盘触发
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            //更新表格行状态
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            // 修改密码
            changepwd(){
                let that = this
                that.isShowChangePwd = true
                that.dataChangePwd = {
                    vender_code: that.formInline.Header.Vender_code,
                    pwd: ''
                }
            },
            confirmChangePwd(){
                let that = this
                let parm = that.dataChangePwd
                that.$http.urlpost('/AdminUpdateVendPWD', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowChangePwd = false
                    }
                });
            },
            //
            explain(val){
                let that = this
                if(val == 1){
                    return that.$t('getapi[1231]')//合格供应商
                } else if(val == 2){
                    return that.$t('getapi[1232]')//被撤销
                } else if(val == 3){
                    return that.$t('getapi[1233]')//待审核
                } else {
                    return ''
                }
            },
            //A类：现场审核 B类：是否需要现场审核 C类：年度供应商绩效评估
            getGradeFlag(val){
                let that = this
                if(val == 1){
                    that.formInline.Header.SceneAudit_Flag=1
                }else if(val == 2){
                    that.formInline.Header.HC_Flag=1
                } else if(val == 3){
                    that.formInline.Header.YearPE_Flag=1
                }
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 47,1) < 1){
                    return false
                }
                let flag = that.oldFormInline != JSON.stringify(that.formInline)
                return flag
            }
        }
    };
</script>

<style lang="less" scoped>
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                margin-right: 5px;
                display: inline-block;
            }
        }
    }
    /deep/.gray{
        background: #d9d6d5;
    }
</style>
